import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'fi-selected-files-list',
    template: `
        @for (file of filesList$ | async; track file) {
          <div class="fi-selected-files-list-item">
            <fi-file-preview [previewFile]="file"></fi-file-preview>
            <div class="file-name">{{ file.name }}</div>
            <span (click)="removeClick(file)" class="fas fa-trash-alt fa-lg BrandedColorHover"></span>
          </div>
        }
        `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./selected-files-list.component.scss'],
    host: { class: 'fi-selected-files-list' },
    standalone: false,
})
export class FiSelectedFilesListComponent {
    @Input() filesList$: BehaviorSubject<File[]>;

    removeClick(file: File) {
        this.filesList$.value.splice(this.filesList$.value.indexOf(file), 1);
    }
}
